import React from "react"

function Container({ children }) {
  return (
    <div className="container-component mx-auto max-w-7xl px-4  sm:px-6 ">
      {children}
    </div>
  )
}

export default Container
